import { createBrowserRouter } from "react-router-dom";
import ElementaryCountdownScreen from "../screens/ElemCountdownScreen";
import Unauthorized403 from "../screens/UnauthorizedScreen";
import ElementaryLeaderboard from "../screens/ElementaryLeaderboard";
import ElementaryPerformanceScreen from "../screens/ElementaryPerformance";
import HomeScreen from "../screens/HomeScreen";
import { ProtectedRoutes } from "../components/ProtectedRoute";
import ChallengeScreen from "../screens/ChallengeScreen";

export const router = createBrowserRouter([
    {
        path: "/leaderboard",
        element: <ElementaryLeaderboard/>
    },
    {
        path:"/",
        element: <HomeScreen/>
    },
    {
        element: <ProtectedRoutes/>,
        children: [
            {
                path: "/:host",
                element: <ChallengeScreen/>
            },
            {
                path: "/:host/game/:rid",
                element: <ElementaryCountdownScreen/>
            },
            {
                path: "/:host/review/:rid",
                element: <ElementaryPerformanceScreen/>
            },
        ]
    },

    {
        path:"*",
        element: <Unauthorized403/>
    }
    
]);